import { defineComponent } from "vue";
import { useRegisterTestStore } from "@/store/RegisterTestStore";
import { mapState } from "pinia";
import ThemesHelper from "@/helpers/ThemesHelper";

export default defineComponent({
  computed: {
    ...mapState(useRegisterTestStore, ["patient"]),
  },
  data() {
    return {
      loaderImg: ThemesHelper.getThemeParams("urlPathLoaderFile"),
      testName: ThemesHelper.getThemeParams("testName"),
    };
  },
});
